export default {
  title: 'Add file: {{slot}}',
  replace_title: 'Replace file: {{slot}}',
  replace_description: 'The new file takes the place of this one. We keep the old one in our records.',
  form: {
    kind: {
      label: 'Type of ID',
      options: {
        passport: 'Passport',
        driver_license: "Driver's license",
        id_card: 'ID card',
        residence_permit: 'Residence permit',
      },
    },
    front: {
      label: 'Front',
    },
    back: {
      label: 'Back',
    },
    file: {
      label: 'File',
    },
    expires_at: {
      label: 'Valid until',
      placeholder: 'Select a date',
    },
    holder: {
      label: 'Whose ID is this?',
      options: {
        owner: "Mine, the owner's",
        partner: "A partner's",
      },
    },
    holder_name: {
      label: "Partner's name",
      placeholder: 'First and last name',
    },
  },
  accepted_files: 'PDF, JPG or PNG, up to {{max}} MB.',
  accepted_images_min: 'A photo must be at least {{min}} KB.',
  errors: {
    file_type: 'Only PDF, JPG or PNG files are accepted.',
    file_too_large: 'The file is larger than {{max}} MB.',
    file_too_small: 'A photo must be at least {{min}} KB.',
  },
  buttons: {
    select_file: 'Select file',
    submit: 'Upload',
    cancel: 'Cancel',
  },
  toasts: {
    success: 'File uploaded',
    error: 'The file could not be uploaded.',
  },
};
